import { HStack, Text, type StackProps } from '@chakra-ui/react'

/** Wordmark: square "D" mark + name. `minimal` shows only the mark (collapsed sidebar). */
export const Logo = ({ minimal = false, ...props }: StackProps & { minimal?: boolean }) => (
  <HStack gap={2} {...props}>
    <svg width='28' height='28' viewBox='0 0 32 32' aria-hidden>
      <rect width='32' height='32' rx='8' fill='currentColor' />
      <path
        d='M9 8h6.5c5 0 8.5 3.3 8.5 8s-3.5 8-8.5 8H9V8zm4 3.5v9h2.4c2.8 0 4.6-1.8 4.6-4.5s-1.8-4.5-4.6-4.5H13z'
        fill='var(--chakra-colors-bg)'
      />
    </svg>
    {!minimal && (
      <Text as='span' fontWeight='bolder' fontSize='md' letterSpacing='-0.01em' whiteSpace='nowrap'>
        DAVINCI Elections
      </Text>
    )}
  </HStack>
)
